import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
  TableHeader,
  TableLoader,
} from "../../components/commons";
import EWayBillGenerate from "../../components/InvoiceGeneration/EWayBillModal/EWayBillGenerate";
import EWayBillExtend from "../../components/InvoiceGeneration/EWayBillModal/EWayBillExtend";
import EWayBillCancel, {
  CANCEL_EWAYBILL_OPTION,
} from "../../components/InvoiceGeneration/EWayBillModal/EWayBillCancel";
import EWayBillAction from "../../components/InvoiceGeneration/EWayBillModal/EWayBillAction";
import {
  BusinessAddressIcon,
  CustomerSupplierDetailsIcon,
  DocumentIcon,
  InfoViolet,
  NewDownloadIcon,
  NewDownloadIconActive,
  RedErrorIcon,
  TableEditRedIcon,
  TruckIcon,
  ValueIcon,
  WarningIcon,
} from "../../assets/images";
import EWayBillTableData from "../../components/InvoiceGeneration/EWayBillModal/EWayBillTableData";
import { EWayBill_HEADERS } from "../../constant/invoiceListConst";
import {
  convertEinvoicePasswordToHash,
  formatDate,
  reverseDate,
} from "../../utils/commonFunctions";
import {
  AuthorizationType,
  DeleteInvoicesListPayloadType,
  EinvoiceAuthenticationDataPayloadType,
  EWayBillCancelDataPayloadType,
  EWayBillDataPayloadType,
  EWayBillPayloadDownloadType,
  ExtendEWayBillPayloadType,
  GenerateEWayBillPayloadType,
  GetAllExpensesInvoicesListPayloadType,
} from "../../commonTypes/invoiceGenerationTypes";
import toast, { Toaster } from "react-hot-toast";
import {
  EWayBillReviewDataType,
  GetAllExpensesInvoicesListType,
} from "../../redux/invoiceGeneration/invoiceGenrationTypes";
import {
  GetAllLedgersListPayloadType,
  GetSingleCustomerSupplierListPayloadType,
} from "../../commonTypes/clientSettingsTypes";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { SendInvoiceEmailData } from "../../components/InvoiceGeneration/ExpenseEntry/ExpenseInvoicesList";
import { CustomerSupplierListType } from "../../redux/clientSettings/clientSettingTypes";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { RootState } from "../../redux/rootReducers";
import { connect } from "react-redux";
import {
  cancelEWayBillDataAction,
  getAllExpensesInvoicesListAction,
  getGenerateEWayBillAction,
  getReviewEWayBillDataAction,
  postEwayBillAuthenticationAction,
  resetEWayBillError,
  resetEWayBillReviewData,
  resetExpenseInvoicesList,
  resetExpenseInvoicesTotal,
  resetInvoiceGenerationError,
  resetInvoiceGenerationSuccess,
  resetSuccess,
} from "../../redux/invoiceGeneration";
import { resetSession } from "../../redux/auth";
import { deleteInvoiceAction } from "../../redux/invoicing";
import { UserIcon } from "../../components/Icon";
import AuthorizationModal from "../../components/InvoiceGeneration/AuthorizationModal/AuthorizationModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import UpdateEWayBillDetails from "../../components/InvoiceGeneration/EWayBillModal/UpdateEWayBillDetails";
import FileSaver from "file-saver";
import { eWayBillPayloadDownloadApi } from "../../apis/invoiceGenerationApis";

type AppProps = {
  token: string | null;
  client_code: number;
  history: any;
  company_name: string;
  fetching: boolean;
  bulkUploadFetching: boolean;
  success: number | null;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  dispatchResetInvoiceGenerationErrorAction: () => void;
  dispatchResetMessageAndSuccess: () => void;
  dispatchResetSession: () => void;
  dispatchResetExpenseInvoicesTotal: () => void;
  dispatchResetExpenseInvoicesListAction: () => void;

  loginData: LoginResponseType;

  dispatchResetEWayBillReviewData: () => void;
  dispatchGetGenerateEWayBillAction: (
    data: GenerateEWayBillPayloadType
  ) => void;
  dispatchResetEWayBillError: () => void;
  dispatchGetPreviewEWayBillData: (data: EWayBillDataPayloadType) => void;
  eWayBillReviewData: EWayBillReviewDataType;
  eWayBillError: string;
  dispatchCancelEWayBillDataAction: (
    data: EWayBillCancelDataPayloadType
  ) => void;
  dispatchPostAuthenicateEwaybillDataAction: (
    data: EinvoiceAuthenticationDataPayloadType
  ) => void;
};

const EwayBill = ({
  token,
  client_code,
  history,
  message,
  company_name,
  fetching,
  success,
  error,
  statusCode,

  dispatchResetSession,
  dispatchResetMessageAndSuccess,
  dispatchResetInvoiceGenerationErrorAction,

  dispatchResetEWayBillReviewData,
  dispatchGetGenerateEWayBillAction,
  dispatchGetPreviewEWayBillData,
  eWayBillError,
  eWayBillReviewData,
  dispatchResetEWayBillError,
  dispatchCancelEWayBillDataAction,
  dispatchPostAuthenicateEwaybillDataAction,
}: AppProps) => {
  const [isEWayPresent, setIsEWayPresent] = useState<number>(0);
  const type = history?.location?.state?.type;

  const clientCode = history?.location?.state?.client_code;
  const invoiceId = history?.location?.state?.invoiceId;

  const [showPreviewEWayBillModal, setShowPreviewEWayBillModal] =
    useState(false);
  const [eWayBillAt, setEeWayBillAt] = useState<string | null>(null);
  const [cancelEWayBillComment, setCancelEWayBillComment] =
    useState<string>("");
  const [eWayBillRadioValue, setEWayBillRadioValue] = useState<string>(
    CANCEL_EWAYBILL_OPTION[0]?.id
  );
  const [generateEWayBill, setGenerateEWayBill] =
    useState<GenerateEWayBillPayloadType>({
      token,
      client_code: null,
      invoice_id: null,
      invoice_type: type, // expenses or revenues,
      sub_supply_type: "",
      transporter_id: "", //GST of transporter
      transporter_name: "",
      transporter_document_number: "",
      transporter_document_date: "",
      transportation_mode: "",
      transportation_distance: "",
      vehicle_number: "",
      vehicle_type: "",
      transaction_type: "Regular",
      type,
    });
      const [eWayBillPayloadDownload, setEWayBillPayloadDownload] =
    useState<GenerateEWayBillPayloadType>({
      token,
      client_code: null,
      invoice_id: null,
      invoice_type: type, // expenses or revenues,
      sub_supply_type: "",
      transporter_id: "", //GST of transporter
      transporter_name: "",
      transporter_document_number: "",
      transporter_document_date: "",
      transportation_mode: "",
      transportation_distance: "",
      vehicle_number: "",
      vehicle_type: "",
      transaction_type: "Regular",
      type,
    });
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [showFillForm, setShowFillForm] = useState(false);
  const [enableDownload, setEnableDownload] = useState<boolean>(false);
  const [isEWayBillSalesPresent, setIsEWayBillSalesPresent] = useMenuCheck();
  const [isEWayBillGenerateSales, setIsEWayBillGenerateSales] = useMenuCheck();
  const [isEWayBillCancelSales, setIsEWayBillCancelSales] = useMenuCheck();
  const [isEWayBillExtendSales, setIsEWayBillExtendSales] = useMenuCheck();
  const [isUpdateEWayBillSales, setUpadteIsEWayBillSales] = useMenuCheck();
  const [isEWayBillDownloadSales, setIsEWayBillDownloadSales] = useMenuCheck();
  const [isEWayBillPayloadDownloadSales, setIsEWayBillPayloadDownloadSales] = useMenuCheck();
  //////

  const [isEWayBillExpensesPresent, setIsEWayBillExpensesPresent] =
    useMenuCheck();
  const [isEWayBillGenerateExpenses, setIsEWayBillGenerateExpenses] =
    useMenuCheck();
  const [isEWayBillCancelExpenses, setIsEWayBillCancelExpenses] =
    useMenuCheck();
  const [isEWayBillExtendExpenses, setIsEWayBillExtendExpenses] =
    useMenuCheck();
  const [isUpdateEWayBillExpenses, setUpadteIsEWayBillExpenses] =
    useMenuCheck();
  const [isEWayBillDownloadExpenses, setIsEWayBillDownloadExpenses] =
    useMenuCheck();
  const [isEWayBillPayloadDownloadExpenses, setIsEWayBillPayloadDownloadExpenses] =
    useMenuCheck();
  /////
  const [showCancelForm, setShowCancelFillForm] = useState(false);
  const [showExtendFillForm, setShowExtendFillForm] = useState(false);
  const [updateEWayBillDetails, setUpdateEWayBillDetails] = useState(false);
  const [data, setData] = useState<AuthorizationType>({
    userName: "",
    password: "",
  });
  const [inputDetailsError, setInputDetailsError] = useState({
    transporterName: "",
    transporterId: "",
    transportationDistance: "",
    transportationMode: "",
    vehicleType: "",
    vehicleNumber: "",
    subSupply: "",
    transporterDocumentNumber: "",
    transporterDocumentDate: "",
    transactionType: "",
  });

  const [eWayBillExtendForm, setEWayBillExtendForm] =
    useState<ExtendEWayBillPayloadType>({
      client_code: clientCode,
      invoice_id: invoiceId,
      invoice_type: type,
      remaining_distance: null,
      extend_validity_reason: "",
      extend_remarks: "",
      from_pincode: null,
      consignment_status: "",
      transit_type: "",
      address_line1: "",
      address_line2: "",
      address_line3: "",
      transporter_document_date: null,
      transporter_document_number: "",
      mode_of_transport: "",
      vechile_number: "",
      current_place_of_consignor: "",
      current_state_of_consignor: "",
      type: type,
    });
  const [extendInputDetailsError, setExtendInputDetailsError] = useState({
    remainingDistance: "",
    extendValidityReason: "",
    extendRemarks: "",
    fromPincode: "",
    consignmentStatus: "",
    transitType: "",
    transporterDocumentDate: "",
    transporterDocumentNumber: "",
    modeOfTransport: "",
    vechileNumber: "",
    currentStateOfConsignor: "",
    currentPlaceOfConsignor: "",
  });


  useEffect(() => {
    setEnableDownload(false);
    if (invoiceId) {
      let finalData = {
        token,
        client_code: clientCode,
        invoice_id: +invoiceId,
        invoice_type: type,
        type,
      };

      dispatchGetPreviewEWayBillData(finalData);
    }
  }, []);

  useEffect(() => {
    if (error?.includes("Please Authenticate the User") ) {
      return toggleAuthorization();
    }
    
     else if (error?.includes("Error in authenticating user!")) {
      toast.error("Error in authenticating user!", {
        duration: 3000,
      });
      dispatchResetMessageAndSuccess();
      dispatchResetInvoiceGenerationErrorAction();
    } else if (error?.includes("E-way Bill authentication unsuccessfull")) {
      toast.error("Either Username, Password or GSTIN is Wrong!", {
        duration: 3000,
      });
      dispatchResetMessageAndSuccess();
      dispatchResetInvoiceGenerationErrorAction();
    }
  }, [error]);

  useEffect(()=>{
    if(eWayBillError==="Invalid auth token"){
       dispatchResetMessageAndSuccess();
    dispatchResetInvoiceGenerationErrorAction();
    setIsAuthorized((prev) => !prev);
    }

  },[eWayBillError])

  useEffect(() => {
    dispatchResetEWayBillReviewData();
    setCancelEWayBillComment("");
    dispatchResetEWayBillError();
    dispatchResetInvoiceGenerationErrorAction();
    setEWayBillRadioValue(CANCEL_EWAYBILL_OPTION[0]?.id);
    setIsEWayBillSalesPresent("E-Way bill sales", "menu");
    setIsEWayBillGenerateSales("Generate E-way bill sales", "menu");
    setIsEWayBillCancelSales("Cancel E-Way bill sales", "menu");
    setIsEWayBillExtendSales("Extend E-Way bill revenues", "menu");
    setUpadteIsEWayBillSales("Update E-Way bill sales", "menu");
    setIsEWayBillDownloadSales("E-Way bill sales download", "menu");
    setIsEWayBillPayloadDownloadSales("E-Way Bill Download Payload Sales", "menu")
    ////
    setIsEWayBillExpensesPresent("E-Way bill expenses", "menu");
    setIsEWayBillGenerateExpenses("Generate E-Way bill expenses", "menu");
    setIsEWayBillCancelExpenses("Cancel E-Way bill expenses", "menu");
    setIsEWayBillExtendExpenses("Extend E-Way bill expenses", "menu");
    setUpadteIsEWayBillExpenses("Update E-Way bill expenses", "menu");
    setIsEWayBillDownloadExpenses("E-Way bill expenses download", "menu");
    setIsEWayBillPayloadDownloadExpenses("E-Way Bill Payload Download Expense", "menu");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (message === "E-Way Bill created successfully") {
      setShowFillForm(false);
      setShowCancelFillForm(false);
      setShowExtendFillForm(false);
      setGenerateEWayBill({
        token,
        client_code: null,
        invoice_id: null,
        invoice_type: type,
        sub_supply_type: "",
        transporter_id: "",
        transporter_name: "",
        transporter_document_number: "",
        transporter_document_date: "",
        transportation_mode: "",
        transportation_distance: "",
        vehicle_number: "",
        vehicle_type: "",
        transaction_type: "Regular",
        type,
      });
    }
    if (message === "E-Way Bill has been cancelled successfully") {
      setShowFillForm(false);
      setShowCancelFillForm(false);
      setShowExtendFillForm(false);
      setCancelEWayBillComment("");
      setEWayBillRadioValue(CANCEL_EWAYBILL_OPTION[0]?.id);
    }
    if (message === "E-Way Bill has been extended successfully") {
      setShowFillForm(false);
      setShowCancelFillForm(false);
      setShowExtendFillForm(false);
      setGenerateEWayBill({
        token,
        client_code: null,
        invoice_id: null,
        invoice_type: type,
        sub_supply_type: "",
        transporter_id: "",
        transporter_name: "",
        transporter_document_number: "",
        transporter_document_date: "",
        transportation_mode: "",
        transportation_distance: "",
        vehicle_number: "",
        vehicle_type: "",
        transaction_type: "Regular",
        type,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  useEffect(() => {
    setIsEWayPresent(eWayBillReviewData?.eway_bill_status);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eWayBillReviewData?.eway_bill_status]);

  useEffect(() => {
    if (message?.includes("Authentication successfull") && success === 1) {
      toast.success("Authentication successful !", {
        duration: 3000,
      });
      toggleAuthorization();
      dispatchResetMessageAndSuccess();
      dispatchResetInvoiceGenerationErrorAction();
      dispatchResetEWayBillError();
      setData({
        ...data,
        userName: "",
        password: "",
      });
    } else if (
      message?.includes("E-Way Bill has been extended successfully") &&
      success === 1
    ) {
      toast.success("E-Way Bill has been extended successfully", {
        duration: 3000,
      });
      dispatchResetMessageAndSuccess();
      dispatchResetInvoiceGenerationErrorAction();
      if (invoiceId) {
        let finalData = {
          token,
          client_code: clientCode,
          invoice_id: +invoiceId,
          invoice_type: type,
          type,
        };

        dispatchGetPreviewEWayBillData(finalData);
      }
    } else if (
      message?.includes("E-Way Bill created successfully") &&
      success === 1
    ) {
      toast.success("E-Way Bill created successfully", {
        duration: 3000,
      });
      dispatchResetMessageAndSuccess();
      dispatchResetInvoiceGenerationErrorAction();
      if (invoiceId) {
        let finalData = {
          token,
          client_code: clientCode,
          invoice_id: +invoiceId,
          invoice_type: type,
          type,
        };

        dispatchGetPreviewEWayBillData(finalData);
      }
    } else if (
      message?.includes("E-Way Bill has been cancelled successfully") &&
      success === 1
    ) {
      toast.success("E-Way Bill has been cancelled successfully", {
        duration: 3000,
      });
      dispatchResetMessageAndSuccess();
      dispatchResetInvoiceGenerationErrorAction();
      if (invoiceId) {
        let finalData = {
          token,
          client_code: clientCode,
          invoice_id: +invoiceId,
          invoice_type: type,
          type,
        };

        dispatchGetPreviewEWayBillData(finalData);
      }
    } else if (message === "Vehicle details has been updated successfully.") {
      toast.success("Vehicle details has been updated successfully.", {
        duration: 3000,
      });
      dispatchResetMessageAndSuccess();
      setUpdateEWayBillDetails(!updateEWayBillDetails);
      if (invoiceId) {
        let finalData = {
          token,
          client_code: clientCode,
          invoice_id: +invoiceId,
          invoice_type: type,
          type,
        };

        dispatchGetPreviewEWayBillData(finalData);
      }
    } else if (
      message === "Transporter details has been updated successfully."
    ) {
      toast.success("Transporter details has been updated successfully.", {
        duration: 3000,
      });
      dispatchResetMessageAndSuccess();
      setUpdateEWayBillDetails(!updateEWayBillDetails);
      if (invoiceId) {
        let finalData = {
          token,
          client_code: clientCode,
          invoice_id: +invoiceId,
          invoice_type: type,
          type,
        };

        dispatchGetPreviewEWayBillData(finalData);
      }
    }
  }, [message, success]);

  const submitEWayBillForm = () => {
    setEnableDownload(!enableDownload);
    const errors: any = {};
    if (generateEWayBill?.sub_supply_type?.length == 0) {
      errors.subSupply = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          subSupply: "error",
        };
      });
    }

    if (generateEWayBill?.transportation_distance.toString()?.length === 0) {
      errors.transportationDistance = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          transportationDistance: "error",
        };
      });
    }

    if (!generateEWayBill?.transportation_mode) {
      errors.transportationMode = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          transportationMode: "error",
        };
      });
    }
    if (
      generateEWayBill?.transportation_mode === "Road" &&
      generateEWayBill?.vehicle_type?.length === 0
    ) {
      if (generateEWayBill?.vehicle_type?.length === 0) {
        errors.vehicleType = "error";
        setInputDetailsError((prv: any) => {
          return {
            ...prv,
            vehicleType: "error",
          };
        });
      }
    }
    if (
      generateEWayBill?.transportation_mode === "Road" &&
      generateEWayBill?.vehicle_number?.length === 0
    ) {
      if (generateEWayBill?.vehicle_number?.length === 0) {
        errors.vehicleNumber = "error";
        setInputDetailsError((prv: any) => {
          return {
            ...prv,
            vehicleNumber: "error",
          };
        });
      }
    }

    if (
      (generateEWayBill?.transportation_mode === "Air" ||
        generateEWayBill?.transportation_mode === "Ship" ||
        generateEWayBill?.transportation_mode === "Rail") &&
      (generateEWayBill?.transporter_document_date?.length === 0 ||
        generateEWayBill?.transporter_document_number?.length === 0)
    ) {
      if (generateEWayBill?.transporter_document_number?.length === 0) {
        errors.transporterDocumentNumber = "error";
        setInputDetailsError((prv: any) => {
          return {
            ...prv,
            transporterDocumentNumber: "error",
          };
        });
      }
    }

    if (Object.keys(errors).length > 0) {
      toast.error("Please Fill Required Fields!", {
        duration: 2000,
      });
      setInputDetailsError(errors);
    } else {
      handleEWayBillGenerate();
    }
  };

  const downloadEWayBillPayload = () => {
    if(token && enableDownload == true){
    
      if(eWayBillPayloadDownload && token) {
        handleDownload(eWayBillPayloadDownload);
      }
    }
  };

  const handleDownload = (params: EWayBillPayloadDownloadType) => {
    let reportName = `${clientCode}_E-WAY_BILL_JSON.json`;

    eWayBillPayloadDownloadApi(params).then((response: any) => {
      const jsonData = JSON.stringify(response.data, null, 2);
      const blob = new Blob([jsonData], {
        type: "application/json;charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);

      toast.success("JSON File Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  const handleEWayBillGenerate = () => {
    dispatchResetEWayBillError();
    const finalData = {
      ...generateEWayBill,
    transaction_type:
        generateEWayBill?.transaction_type === "Regular"
          ? 1
          : generateEWayBill?.transaction_type === "Bill To - Ship To"
          ? 2
          : generateEWayBill?.transaction_type === "Bill From - Dispatch From"
          ? 3
          : 4,
          transporter_document_date: generateEWayBill?.transporter_document_date
        ? reverseDate(generateEWayBill?.transporter_document_date)
        : null,
      client_code: clientCode,
      invoice_id: +invoiceId,
    };
    setEWayBillPayloadDownload(finalData)
    
    dispatchGetGenerateEWayBillAction(finalData);
  };

  const changeHeaders = (name: string) => {
    switch (name) {
      case "total_assessable_value":
        return "Total Assessable";
      case "total_cgst_value":
        return "Total CGST";
      case "total_sgst_value":
        return "Total SGST";
      case "total_igst_value":
        return "Total IGST";
      case "taxable_amount":
        return "Taxable Value";
      case "total_discount":
        return "Total Discount";
      case "total_invoice_value":
        return "Total Value";
      case "number_of_item":
        return "Number of Item";
      case "document_type":
        return "Document Type";
      case "document_number":
        return "Voucher/Invoice Number";
      case "document_date":
        return "Voucher/Invoice Date";
      case "address1":
        return "Address 1";
      case "address2":
        return "Address 2";
      case "legal_name":
        return "Legal Name";
      case "trade_name":
        return "Trade Name";
      case "location":
        return "Location";
      case "pincode":
        return "Pin Code";
      case "gstin":
        return "GSTIN";
      case "state_code":
        return "State Code";
      case "email":
        return "Email";
      case "phone_number":
        return "Phone Number";
      case "item_serial_number":
        return "Serial No.";
      case "product_description":
        return "Description as per Bill";
      case "unit":
        return "Unit";
      case "place_of_supply":
        return "Place of Supply";
      case "quantity":
        return "Quantity";
      case "hsn_code":
        return "HSN/SAC Code";
      case "discount":
        return "Discount";
      case "unit_price":
        return "Unit Price";
      case "total_amount":
        return "Total Amount";
      case "assessable_value":
        return "Assessable Value";
      case "gst_rate":
        return "Gst Percentage";
      case "igst_amount":
        return "IGST Amount";
      case "sgst_amount":
        return "SGST Amount";
      case "cgst_amount":
        return "CGST Amount";
      case "total_item_value":
        return "Total Value";
      case "is_service":
        return "Service";
      case "gstin_of_consignor":
        return "GSTIN ";
      case "legal_name_of_consignor":
        return "Legal Name ";
      case "address1_of_consignor":
        return "Address 1";
      case "address2_of_consignor":
        return "Address 2";
      case "place_of_consignor":
        return "City";
      case "pincode_of_consignor":
        return "Pincode";
      case "state_of_consignor":
        return "State";
      case "actual_from_state_name":
        return "Actual From State Name";
      case "gstin_of_consignee":
        return "GSTIN ";
      case "legal_name_of_consignee":
        return "Legal Name ";
      case "address1_of_consignee":
        return "Address 1 ";
      case "address2_of_consignee":
        return "Address 2 ";
      case "place_of_consignee":
        return "City";
      case "pincode_of_consignee":
        return "Pincode";
      case "state_of_supply":
        return "Place of Supply";
      case "actual_to_state_name":
        return "Actual to State Name";
      case "cess_amount":
        return "CESS Amount";
      case "cess_nonadvol_value":
        return "Cess Nonadvol Value";
      case "transporter_id":
        return "Transporter ID";
      case "transporter_name":
        return "Transporter Name";
      case "transporter_document_number":
        return "Transporter Document Number";
      case "transporter_document_date":
        return "Transporter Document Date";
      case "transportation_mode":
        return "Transportation Mode";
      case "transportation_distance":
        return "Transportation Distance";
      case "vehicle_type":
        return "Vehicle Type";
      case "gstin_of_shipping_address":
        return "GSTIN";
      case "legal_name_of_shipping_address":
        return "Legal Name";
      case "address1_of_shipping_address":
        return "Address 1";
      case "address2_of_shipping_address":
        return "Address 2";
      case "place_of_shipping_address":
        return "City";
      case "pincode_of_shipping_address":
        return "Pincode";
      case "state_of_shipping_address":
        return "Place of Supply"
      default:
        return name;
    }
  };
  const createRows = (data: any, obj: any) => {
    let finalData = data?.filter(
      (item: string) =>
        item != "cess_nonadvol_value" &&
        item != "actual_from_state_name" &&
        item != "actual_to_state_name" &&
        item != "state_id_of_consignor"
    );
    let rowCreated = finalData?.map((item: any) => {
      return (
        <div className="one-input">
          <div className="inside-row-e-invoice">{changeHeaders(item)}</div>
          <div className="row-einvoice">
            {obj[item]
              ? item === "document_date"
                ? formatDate(obj[item])
                : obj[item]
              : "--"}
          </div>
        </div>
      );
    });
    return rowCreated;
  };

  const handleExtendShow = () => {
    setShowExtendFillForm(true);
    dispatchResetEWayBillError();
    setShowCancelFillForm(false);
    setShowFillForm(false);
    setEWayBillExtendForm({
      client_code: clientCode,
      invoice_id: invoiceId,
      invoice_type: type,
      remaining_distance: null,
      extend_validity_reason: "",
      extend_remarks: "",
      from_pincode: null,
      consignment_status: "",
      transit_type: "",
      address_line1: "",
      address_line2: "",
      address_line3: "",
      transporter_document_date: null,
      transporter_document_number: "",
      mode_of_transport: "",
      vechile_number: "",
      current_place_of_consignor: "",
      current_state_of_consignor: "",
      type: type,
    });
    setCancelEWayBillComment("");
    setEWayBillRadioValue(CANCEL_EWAYBILL_OPTION[0]?.id);
  };

  const handleSubmitAuthenication = async () => {
    let finalPassword = await convertEinvoicePasswordToHash(data.password);
    if (token) {
      let finalData = {
        userName: data?.userName,
        password: finalPassword,
        token,
        gstin: eWayBillReviewData?.consignor_details?.gstin_of_consignor,
        clientCode,
      };
      dispatchPostAuthenicateEwaybillDataAction(finalData);
    }
  };

  const handleCancelShow = () => {
    dispatchResetEWayBillError();
    setShowCancelFillForm(true);
    setShowExtendFillForm(false);
    setShowFillForm(false);
    setEWayBillExtendForm({
      client_code: clientCode,
      invoice_id: invoiceId,
      invoice_type: type,
      remaining_distance: null,
      extend_validity_reason: "",
      extend_remarks: "",
      from_pincode: null,
      consignment_status: "",
      transit_type: "",
      address_line1: "",
      address_line2: "",
      address_line3: "",
      transporter_document_date: null,
      transporter_document_number: "",
      mode_of_transport: "",
      vechile_number: "",
      current_place_of_consignor: "",
      current_state_of_consignor: "",
      type: type,
    });
    setCancelEWayBillComment("");
    setEWayBillRadioValue(CANCEL_EWAYBILL_OPTION[0]?.id);
  };

  const toggleAuthorization = () => {
    dispatchResetMessageAndSuccess();
    dispatchResetInvoiceGenerationErrorAction();
    setIsAuthorized((prev) => !prev);
  };

  const handleCancelEWayBill = () => {
    dispatchResetEWayBillError();
    let payload = {
      client_code: clientCode,
      token,
      invoice_type: type,
      invoice_id: +invoiceId,
      reason_of_cancel: eWayBillRadioValue,
      cancel_remarks: cancelEWayBillComment,
      type: type,
    };
    dispatchCancelEWayBillDataAction(payload);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const handleUpdateEWayBillDetails = () => {
    setUpdateEWayBillDetails(!updateEWayBillDetails);
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        if (
          error?.includes("Please Authenticate the User") ||
          error?.includes("Error in authenticating user!") ||
          error?.includes("Vehicle details could not be updated!") ||
          error?.includes("Transporter details could not be updated!")
        ) {
          return;
        }
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title={"Error"}
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetInvoiceGenerationErrorAction();
              dispatchResetMessageAndSuccess();
            }}
          />
        );
      }
    } else {
      if (
        success === 1 &&
        !!message &&
        (message === "E-invoicing created successfully" ||
          message === "E-invoice has been cancelled successfully.")
      ) {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message={
              message === "E-invoicing created successfully"
                ? "E-Invoicing Created Successfully!"
                : message === "E-invoice has been cancelled successfully."
                ? "E-Invoicing Cancelled Successfully!"
                : null
            }
            buttonText="OK"
            onPress={() => {
              dispatchResetMessageAndSuccess();
              dispatchResetInvoiceGenerationErrorAction();
              history.goBack();
            }}
            statusCode={statusCode}
          />
        );
      }
    }

    return false;
  };

  const handleButtonText = (text: string) => {
    return (
      <button
        className="btn btn-primary"
        style={{ color: "#FFFFFF", textTransform: "capitalize" }}
      >
        {text}
      </button>
    );
  };
  let extendButtonCondition =
    fetching ||
    eWayBillReviewData?.eway_bill_status === 0 ||
    eWayBillReviewData?.eway_bill_status === 2
      ? ""
      : (type === "revenues" && isEWayBillExtendSales) ||
        (type === "expenses" && isEWayBillExtendExpenses)
      ? "Extend E-Way Bill"
      : "";
  let updateButtonCondition =
    fetching ||
    eWayBillReviewData?.eway_bill_status === 0 ||
    eWayBillReviewData?.eway_bill_status === 2
      ? ""
      : (type === "revenues" && isUpdateEWayBillSales) ||
        (type === "expenses" && isUpdateEWayBillExpenses)
      ? "Extend E-Way Bill"
      : "";
  let cancelButtonCondition =
    fetching ||
    eWayBillReviewData?.eway_bill_status === 0 ||
    eWayBillReviewData?.eway_bill_status === 2
      ? ""
      : (type === "revenues" && isEWayBillCancelSales) ||
        (type === "expenses" && isEWayBillCancelExpenses)
      ? "Cancel E-Way Bill"
      : "";
  const isEWayDownloadCondition =
    isEWayPresent === 1 ||
    (isEWayPresent === 3 && !!eWayBillReviewData?.eway_bill_number);

  const isDownloadConditionMet =
    (type === "revenues" &&
      isEWayBillDownloadSales &&
      isEWayDownloadCondition) ||
    (type === "expenses" &&
      isEWayBillDownloadExpenses &&
      isEWayDownloadCondition);
  const EWayBillModalBody = () => {
    return !fetching ? (
      <div className="e-way-bill">
        <div className="d-flex justify-content-between mb-2">
          <div>
            {isEWayPresent === 1 ||
            (isEWayPresent === 3 && !!eWayBillReviewData?.eway_bill_number) ? (
              <div className=" ml-4 mt-1 mb-1 irn">
                {" "}
                <div>
                  <span style={{ fontWeight: "500" }}>E-Way Bill No. </span> :{" "}
                  {eWayBillReviewData?.eway_bill_number}
                </div>
              </div>
            ) : null}
          </div>
          <div>
            {updateButtonCondition ? (
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 250 }}
                overlay={
                  <Tooltip id="button-view-download">
                    Update E-Way Bill Details
                  </Tooltip>
                }
              >
                <button
                  className="btn"
                  style={{
                    border: "1px solid #dd4433",
                    height: "35px",
                    width: "fit-content",
                  }}
                  onClick={() => {
                    setUpdateEWayBillDetails(!updateEWayBillDetails);
                  }}
                >
                  <img
                    src={TableEditRedIcon}
                    alt=""
                    style={{ marginTop: "-5px" }}
                  />
                </button>
              </OverlayTrigger>
            ) : (
              ""
            )}
            {isDownloadConditionMet ? (
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 250 }}
                overlay={
                  <Tooltip id="button-view-download-invoice">
                    Note: This button redirects to the official government
                    website to download the e-Way Bill.
                  </Tooltip>
                }
              >
                <a
                  className={`btn  mr-2`}
                  style={{ color: "#FFFFFF", textTransform: "capitalize" }}
                  href={eWayBillReviewData?.eway_bill_pdf_url}
                >
                  <button
                    className="btn form-control d-flex"
                    style={{ border: "1px solid #dd4433", height: "34px" }}
                    onClick={() =>
                      window.open(
                        "https://ewaybillgst.gov.in/Others/EBPrintnew.aspx",
                        "_blank"
                      )
                    }
                  >
                    <img src={NewDownloadIconActive} alt="" />
                  </button>
                </a>
              </OverlayTrigger>
            ) : null}
            {extendButtonCondition ? (
              <button
                disabled={showExtendFillForm}
                onClick={handleExtendShow}
                className="btn btn-primary mr-2"
              >
                Extend E-Way Bill
              </button>
            ) : (
              ""
            )}

            {cancelButtonCondition ? (
              <button
                disabled={showCancelForm}
                onClick={handleCancelShow}
                className="btn btn-primary mr-2"
              >
                Cancel E-Way Bill
              </button>
            ) : (
              ""
            )}
             <button
                onClick={()=>setIsAuthorized((prev) => !prev)}
                className="btn btn-outline mr-2"
              >
             Reauthenticate E-Way Bill
              </button>
          </div>
        </div>
        <div
          className={
            isEWayPresent === 1 || eWayBillError?.length
              ? "reverse-einvoice"
              : "reverse-einvoice"
          }
        >
          {/* left side preview  */}

          <div style={{ width: "68%" }}>
            <div className="details-box mb-3">
              <div className={"sub-heading-e-invoice mt-3"}>
                <img src={ValueIcon} alt="ValueIcon" className="mr-2" /> Value
                Details
              </div>

              {eWayBillReviewData?.value_details ? (
                <div
                  className={
                    isEWayPresent === 1 || eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(eWayBillReviewData?.value_details),
                    eWayBillReviewData?.value_details
                  )}
                </div>
              ) : null}
            </div>
            {/* document  */}
            <div className="details-box mb-3">
              <div className={"sub-heading-e-invoice mt-3"}>
                {" "}
                <img src={DocumentIcon} alt="DocumentIcon" className="mr-2" />
                Document Details
              </div>
              {eWayBillReviewData?.document_details ? (
                <div
                  className={
                    isEWayPresent === 1 ||
                    isEWayPresent === 2 ||
                    eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(eWayBillReviewData?.document_details),
                    eWayBillReviewData?.document_details
                  )}
                </div>
              ) : null}
            </div>

            {/* buyer Details  */}
            <div className="details-box mb-3">
              <div className={"sub-heading-e-invoice mt-3"}>
                <img
                  src={BusinessAddressIcon}
                  alt="BusinessAddressIcon"
                  className="mr-2"
                />
                {eWayBillReviewData?.supply_type === "INWARD"
                  ? "Customer/Supplier Details (Consignor)"
                  : "Business Addresses Details (Consignor)"}
              </div>
              {eWayBillReviewData?.consignor_details ? (
                <div
                  className={
                    isEWayPresent === 1 ||
                    isEWayPresent === 2 ||
                    eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(eWayBillReviewData?.consignor_details),
                    eWayBillReviewData?.consignor_details
                  )}
                </div>
              ) : null}
            </div>

            {/* seller Details  */}
            <div className="details-box mb-3">
              <div className={"sub-heading-e-invoice mt-3"}>
                <img
                  src={CustomerSupplierDetailsIcon}
                  alt="CustomerSupplierDetailsIcon"
                  className="mr-2"
                />
                {eWayBillReviewData?.supply_type === "INWARD"
                  ? "Business Addresses Details (Consignee)"
                  : "Customer/Supplier Details (Consignee)"}
              </div>
              {eWayBillReviewData?.consignee_details ? (
                <div
                  className={
                    isEWayPresent === 1 ||
                    isEWayPresent === 2 ||
                    eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(eWayBillReviewData?.consignee_details),
                    eWayBillReviewData?.consignee_details
                  )}
                </div>
              ) : null}
            </div>
            {/* shipping details */}
            {eWayBillReviewData?.shipping_details && 
            Object.keys(eWayBillReviewData.shipping_details).length > 0 && (
            <div className="details-box mb-3">
              <div className={"sub-heading-e-invoice mt-3"}>
                <img
                  src={CustomerSupplierDetailsIcon}
                  alt="CustomerSupplierDetailsIcon"
                  className="mr-2"
                />
                {/* {eWayBillReviewData?.supply_type === "INWARD" */}
                  {/* ?  */}
                  Shipping Address Details
                  {/* : "Customer/Supplier Details (Consignee)"} */}
              </div>
              {eWayBillReviewData?.shipping_details ? (
                <div
                  className={
                    isEWayPresent === 1 ||
                    isEWayPresent === 2 ||
                    eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(eWayBillReviewData?.shipping_details),
                    eWayBillReviewData?.shipping_details
                  )}
                </div>
              ) : null}
            </div>
            )}
            
            <div
              className={
                (eWayBillReviewData?.eway_bill_status === 1 ||
                  eWayBillReviewData?.eway_bill_status === 3) &&
                eWayBillReviewData?.transportation_details
                  ? `details-box mb-3`
                  : ""
              }
            >
              {/* TRANSPORTATION DETAILS  */}
              {eWayBillReviewData?.eway_bill_status === 1 ||
              eWayBillReviewData?.eway_bill_status === 3 ? (
                <div className={"sub-heading-e-invoice mt-3"}>
                  <img src={TruckIcon} alt="TruckIconIcon" className="mr-2" />
                  Transportation Details
                </div>
              ) : (
                ""
              )}
              {(eWayBillReviewData?.eway_bill_status === 1 ||
                eWayBillReviewData?.eway_bill_status === 3) &&
              eWayBillReviewData?.transportation_details ? (
                <div
                  className={
                    isEWayPresent === 1 ||
                    isEWayPresent === 2 ||
                    eWayBillReviewData?.eway_bill_status === 3 ||
                    eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(eWayBillReviewData?.transportation_details),
                    eWayBillReviewData?.transportation_details
                  )}
                </div>
              ) : null}
            </div>
            {/* item list  */}

            <div className={"sub-heading-e-invoice m-0"}>Item Details</div>
            {eWayBillReviewData?.itemList?.length ? (
              <div
                className={"inside-einvoice-items jobsType"}
                style={{ overflowX: "scroll" }}
              >
                <table className="table thead-light table-bordered">
                  <thead className="text-left no-wrap sticky-table-header">
                    <TableHeader tableHeader={EWayBill_HEADERS} />
                  </thead>
                  <tbody>
                    <EWayBillTableData
                      tableHeaders={EWayBill_HEADERS}
                      data={eWayBillReviewData?.itemList}
                    />
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
          </div>
          {/* comment box  */}
          <div style={{ width: "32%" }}>
            {eWayBillError?.length ? (
              <div>
                {eWayBillError?.length && (
                  <div className="px-2">
                    {eWayBillError?.split("||")?.map((item: any) => {
                      return (
                        <div
                          className="mt-2 mb-2 error-msg p-2"
                          style={{
                            border: "1px solid #ba4916",
                            backgroundColor: "#fef2ed",
                            borderRadius: "6px",
                          }}
                        >
                          {item === "Invalid auth token" ? (
                            <>
                              <span className="mr-1">
                                <img src={WarningIcon} alt="error" />
                              </span>
                              <span className="ml-2"> Your password has expired or updated. Kindly reauthenticate to continue.</span>
                            </>
                          ) : (
                            <>
                              <span className="mr-1">
                                <img src={RedErrorIcon} alt="error" />
                              </span>
                              <span className="ml-2">{item}</span>
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            <>
              {!showFillForm && !showCancelForm && !showExtendFillForm ? (
                <>
                  {eWayBillReviewData?.eway_bill_valid_date &&
                  (eWayBillReviewData?.eway_bill_status === 1 ||
                    eWayBillReviewData?.eway_bill_status === 3) ? (
                    <div className="px-2">
                      <div
                        style={{
                          border: "1px solid #744bd1",
                          backgroundColor: "#f5f0ff",
                          borderRadius: "6px",
                          color: "#744bd1",
                        }}
                        className="mt-2 mb-2 error-msg p-2"
                      >
                        <img src={InfoViolet} alt="i-icon" className="mr-2" />{" "}
                        This E-Way Bill is valid upto{" "}
                        {eWayBillReviewData?.eway_bill_valid_date}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <EWayBillAction
                    setShowFillForm={setShowFillForm}
                    data={eWayBillReviewData}
                    isEWayBillGenerate={
                      type == "revenues"
                        ? isEWayBillGenerateSales
                        : isEWayBillGenerateExpenses
                    }
                  />
                </>
              ) : (
                ""
              )}
              {showCancelForm ? (
                <EWayBillCancel
                  data={eWayBillReviewData}
                  eWayBillAt={eWayBillAt}
                  cancelEWayBillComment={cancelEWayBillComment}
                  radioValue={eWayBillRadioValue}
                  setCancelEWayBillComment={setCancelEWayBillComment}
                  setRadioValue={setEWayBillRadioValue}
                  isEWayPresent={isEWayPresent}
                  isEWayBillCancel={
                    type == "revenues"
                      ? isEWayBillCancelSales
                      : isEWayBillCancelExpenses
                  }
                  handleCancelEWayBill={handleCancelEWayBill}
                />
              ) : showExtendFillForm ? (
                <EWayBillExtend
                  clientCode={clientCode}
                  data={eWayBillReviewData}
                  eWayBillInvoiceId={invoiceId}
                  type={type}
                  eWayBillExtend={eWayBillExtendForm}
                  setEWayBillExtend={setEWayBillExtendForm}
                  inputDetailsError={extendInputDetailsError}
                  setInputDetailsError={setExtendInputDetailsError}
                />
              ) : (
                ""
              )}
            </>
            {/* /////transportation details */}
            {(type === "revenues" && isEWayBillGenerateSales && showFillForm) ||
            (type === "expenses" &&
              isEWayBillGenerateExpenses &&
              showFillForm) ? (
              <EWayBillGenerate
                generateEWayBill={generateEWayBill}
                inputDetailsError={inputDetailsError}
                setInputDetailsError={setInputDetailsError}
                setGenerateEWayBill={setGenerateEWayBill}
                submitEWayBillForm={submitEWayBillForm}
                data={eWayBillReviewData}
                type={type}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    ) : (
      <div className="row col-md-12">
        <TableLoader Rows={14} ColumnPerRow={3} />
      </div>
    );
  };

  return (
    <div>
      <>
        <div className="col-md-12">
          <div className="col-md-4 mb-3">
            <CommonHeader
              title={
                eWayBillError?.length
                  ? "Errors In E-Way Bill"
                  : "View E-Way Bill"
              }
            />

            <div className="d-flex align-items-center">
              {client_code ? (
                <>
                  <UserIcon /> &nbsp;
                  {!!company_name ? company_name : company_name}{" "}
                  {"(" + client_code + ")"}
                </>
              ) : null}
            </div>
          </div>
        </div>

        <div className="card">
          <div className="col-md-12 d-flex align-items-center justify-content-end"></div>
          {(isEWayBillPayloadDownloadSales && type === "revenues") || (isEWayBillPayloadDownloadExpenses && type === "expenses") ? (
            <div className="ml-2 text-right">
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 250 }}
              overlay={
                <Tooltip id="button-view-download-invoice">
                  Download JSON
                </Tooltip>
              }
            >
              <button
                onClick={() => downloadEWayBillPayload()}
                // className="btn btn-primary"
                className="btn"
                style={{ border: "1px solid #bfcbe1",
                  backgroundColor: enableDownload == false ?  "#e9ecef" : "transparent"
                 }}
                disabled={enableDownload == false}
              >
                <img src={NewDownloadIcon} alt="download icon" />
              </button>
            </OverlayTrigger>
          </div>
          ) : null}
          
          {isAuthorized ? (
            <AuthorizationModal
              data={data}
              handleChange={handleChange}
              gstData={eWayBillReviewData?.consignor_details}
              type="EwayBill"
              isOpen={isAuthorized}
              toggleAuthorization={toggleAuthorization}
              handleSubmit={handleSubmitAuthenication}
            />
          ) : null}

          <>{EWayBillModalBody()}</>
          {handleErrorModal()}
          <Toaster />
        </div>
        {fetching && <Loader />}
        {updateEWayBillDetails ? (
          <UpdateEWayBillDetails
            isOpen={updateEWayBillDetails}
            toggleModal={() => {
              handleUpdateEWayBillDetails();
            }}
            invoiceId={invoiceId}
            clientCode={clientCode}
            type={type}
          />
        ) : (
          ""
        )}
      </>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  loginData: state.auth.loginData,
  fetching: state.invoiceGeneration.fetching,
  bulkUploadFetching: state.invoiceGeneration.bulkUploadFetching,
  message: state.invoiceGeneration.message,
  success: state.invoiceGeneration.success,
  statusCode: state.invoiceGeneration.statusCode,
  error: state.invoiceGeneration.error,
  eWayBillError: state.invoiceGeneration.eWayBillError,
  eWayBillReviewData: state.invoiceGeneration.eWayBillReviewData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetExpenseInvoicesListAction: () =>
    dispatch(resetExpenseInvoicesList()),

  dispatchResetInvoiceGenerationErrorAction: () =>
    dispatch(resetInvoiceGenerationError()),
  dispatchResetInvoiceGenerationSuccessAction: () =>
    dispatch(resetInvoiceGenerationSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMessageAndSuccess: () => dispatch(resetSuccess()),
  dispatchResetExpenseInvoicesTotal: () =>
    dispatch(resetExpenseInvoicesTotal()),
  dispatchDeleteInvoice: (data: DeleteInvoicesListPayloadType) =>
    dispatch(deleteInvoiceAction(data)),
  dispatchResetEWayBillReviewData: () => {
    dispatch(resetEWayBillReviewData());
  },
  dispatchGetGenerateEWayBillAction: (data: GenerateEWayBillPayloadType) =>
    dispatch(getGenerateEWayBillAction(data)),
  dispatchResetEWayBillError: () => dispatch(resetEWayBillError()),
  dispatchGetPreviewEWayBillData: (data: EWayBillDataPayloadType) =>
    dispatch(getReviewEWayBillDataAction(data)),
  dispatchCancelEWayBillDataAction: (data: EWayBillCancelDataPayloadType) =>
    dispatch(cancelEWayBillDataAction(data)),
  dispatchPostAuthenicateEwaybillDataAction: (
    data: EinvoiceAuthenticationDataPayloadType
  ) => {
    dispatch(postEwayBillAuthenticationAction(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EwayBill);
